import { render } from "./Folders.vue?vue&type=template&id=462c61f3&scoped=true"
import script from "./Folders.vue?vue&type=script&lang=js"
export * from "./Folders.vue?vue&type=script&lang=js"

import "./Folders.vue?vue&type=style&index=0&id=462c61f3&lang=scss&scoped=true"

import exportComponent from "/home/controlcenter/sourcecode/dubiverse/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-462c61f3"]])

export default __exports__